/*
 * FormField Messages
 *
 * This contains all the text for the FormField component.
 */
import { defineMessages } from "react-intl";

const idPrefix = "FormField";

export default defineMessages({
  FS_screenReaderLabel_successDescribedBy: {
    id: `FS.${idPrefix}.screenReaderLabel_successDescribedBy`,
    defaultMessage: "You entered valid data.",
  },

  SS_screenReaderLabel_successDescribedBy: {
    id: `SS.${idPrefix}.screenReaderLabel_successDescribedBy`,
    defaultMessage: "You entered valid data.",
  },
});
